export default __webpack_public_path__ + "static/media/nedb.3c5ab99a.png";